import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {employeeRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {CreateEmployee} from './pages/CreateEmployee/CreateEmployee';
import {EmployeeDetail} from './pages/EmployeeDetail/EmployeeDetail';
import {EmployeeOverview} from './pages/EmployeeOverview/EmployeeOverview';

export const EmployeeModule: Module = {
  id: moduleKeys.employee,
  layoutProps: {
    title: 'module.employee.title',
    icon: 'sidebar/employee_management',
  },
  routerProps: {
    path: employeeRoutes.overview,
    element: <EmployeeOverview />,
  },
  requiredPermission: permissions.employeeRead,
  content: [
    {
      id: 'employee-overview',
      routerProps: {
        path: employeeRoutes.overview,
        element: <EmployeeOverview />,
      },
    },
    {
      id: 'employee-new',
      routerProps: {
        path: employeeRoutes.createEmployee,
        element: <CreateEmployee />,
      },
      requiredPermission: permissions.employeeRead,
      layoutProps: {
        title: 'page.createEmployee.labels.title',
        isPartOfCreateMenuItem: true,
      },
    },
    {
      id: 'employee-detail',
      routerProps: {
        path: employeeRoutes.detail,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-personalInfo',
      routerProps: {
        path: employeeRoutes.personalInfo,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-organizationalPlacement',
      routerProps: {
        path: employeeRoutes.organizationalPlacement,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-organizationalPlacement',
      routerProps: {
        path: employeeRoutes.externalSystems,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-externalAuthorizationSystems',
      routerProps: {
        path: employeeRoutes.externalAuthorizationSystems,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-userDataAndRoles',
      routerProps: {
        path: employeeRoutes.userDataAndRole,
        element: <EmployeeDetail />,
      },
    },
    {
      id: 'employee-activityLogs',
      routerProps: {
        path: employeeRoutes.activityLogs,
        element: <EmployeeDetail />,
      },
    },
  ],
};
